/**
 * @file
 * Attaches the behaviors for the main Menu component.
 */
!(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.searchToggle = {
    attach(context) {
      const $searchToggle = $('.search-toggle', context);

      // If there are no search elements within the context,
      // none of the code below should execute.
      if (!$searchToggle.length) {
        return;
      }

      // Preserve the behavior.
      const self = this;
      const $toggle = $searchToggle.find('button');
      
      $toggle.on('click', function (e) {
        e.preventDefault();
        const $search = $('.l-header__global-search');
        const isExpanded = $search.hasClass('expanded');
        
        self.closeNav();
        
        if (isExpanded) {
          self.closeSearch();
        } else {
          self.openSearch($(this));
        }
      });

      $toggle.on('keydown', function (e) {
        const keyCode = e.keyCode ? e.keyCode : e.which;
        
        // Enter (13) or Space (32) should open the search
        if (keyCode === 13 || keyCode === 32) {
          e.preventDefault();
          self.closeNav();
          self.openSearch($(this));
        }
      });

      // Global ESC key listener to close search
      $(document).on('keydown.searchToggle', function (e) {
        const keyCode = e.keyCode ? e.keyCode : e.which;
        if (keyCode === 27) {
          const $search = $('.l-header__global-search');
          if ($search.hasClass('expanded')) {
            e.preventDefault();
            self.closeSearch();
          }
        }
      });
    },

    openSearch($toggle) {
      const $search = $('.l-header__global-search');
      const $nav = $('.l-header__navigation');

      // Add a close button to the search form
      const $closeButton = $('<button class="close-search-button" aria-label="Close search"> X </button>');
      $search.append($closeButton);

      // Add an overlay element
      const $overlay = $('<div class="search-overlay"></div>');
      $('.l-header__wrap').append($overlay);

      $search
        .addClass('expanded')
        .attr('aria-expanded', 'true')
        .find('input[name="search_result"]').focus();

      $nav.find('.main-nav__menu-item').addClass('no-hover');
      $overlay.addClass('active');

      // Add a click event listener to the close button to close the search
      $closeButton.on('click', function() {
        Drupal.behaviors.searchToggle.closeSearch();
      });
    },

    closeSearch() {
      const $search = $('.l-header__global-search');
      const $nav = $('.l-header__navigation');

      // Remove the close button from the search form
      $search.find('.close-search-button').remove();

      // Close the search form
      $search
        .removeClass('expanded')
        .attr('aria-expanded', 'false');

      // Hide the overlay and reset the menu items
      $('.search-overlay').removeClass('active');
      $nav.find('.main-nav__menu-item').removeClass('no-hover');

      // Return focus to the search toggle button
      const $toggleButton = $('.search-toggle button');
      $toggleButton.focus();
      $toggleButton.addClass('focus-visible');
    },


    closeNav(){
      const $nav = $('.l-header__navigation');
      const state = $nav.hasClass('expanded');
      if(state){
        $nav
          .toggleClass('expanded', false)
          .attr('aria-expanded', false);
      }

      $nav.find('.expanded').each(function(){
        $(this).toggleClass('expanded', false);
      });

      $nav.find('.main-nav__menu-item').toggleClass('no-hover', true);
    }
  };
})(jQuery, Drupal);
